export function clearAllTable()
{
    return({
        type:"CLEAR_ALL_TABLE"
    })
}